import React, {useEffect, useLayoutEffect} from "react";
import PullToRefresh from "react-simple-pull-to-refresh";
import {useNavigate, useNavigationType} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {
	fetchDetailBranchPageScroll,
	fetchBranchSummaryInfo,
	updateDailySummaryInfo, updateBranchPeriodInfo, updateWeeklySummaryInfo, updateMonthlySummaryInfo
} from "redux/slices/sales/salesSlice";

import {isBranchPermission} from "utils/define";
import MainLayout from "layouts/MainLayout";
import SummaryInfo from "./SummaryInfo";
import BranchDetailList from "./BranchDetailList";
import PullToRefreshing from "components/common/PullToRefreshing";



/**
 * [전지점 기간별 매출 조회]
 */

export const BranchDetail = ({mode}) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const navigationType = useNavigationType();
	let {
		searchPartner,
		searchBranch,
		searchDate,
		searchPeriodType,
		data,
		isLoading,
		isError
	} = useSelector(state => state.sales.branchSummaryInfo);
	const partnerInfo = useSelector(state => state.partner);
	const salesInfo = useSelector(state => state.sales);

	useLayoutEffect(() => {
		return () => {
			dispatch(fetchDetailBranchPageScroll("store"));
		};
	}, []);

	useEffect(() => {
		if(!searchPartner) {
			dispatch(fetchBranchSummaryInfo({
				searchPartner : partnerInfo.seqPartner,
				searchDate : salesInfo.searchDate,
				searchPeriodType : salesInfo.searchPeriodType
			}));
		}
		if(!(isBranchPermission(partnerInfo))) {
			navigate("/sales");
			return null;
		}
	}, []);

	useEffect(() => {
		const isUpdate = (
			!data || navigationType != "POP" || (
				searchPartner != data.searchInfo.searchPartner ||
				searchBranch != data.searchInfo.searchBranch ||
				searchDate != data.searchInfo.searchDate ||
				searchPeriodType != data.searchInfo.searchPeriodType
			)
		);
		if(isUpdate) eventHandler.update();
	}, [searchPartner, searchBranch, searchDate, searchPeriodType]);

	const eventHandler = {
		update : () => {
			let updateAction, searchCount ;
			switch(mode) {
				case "daily" : updateAction = updateDailySummaryInfo; searchCount = 1; break;
				case "weekly" : updateAction = updateWeeklySummaryInfo; break;
				case "monthly" : updateAction = updateMonthlySummaryInfo; break;
			}
			dispatch(updateAction({
				searchPartner : searchPartner,
				searchBranch : 0,
				searchDate : searchDate,
				searchCount : searchCount
			}, fetchBranchSummaryInfo, "branchSummaryInfo"));
		},
		changeDate : (date) => {
			dispatch(fetchBranchSummaryInfo({
				searchDate : date
			}));
		},
		changeBranch : (branch) => {
			dispatch(fetchBranchSummaryInfo({
				searchBranch : branch
			}));
		},
		pullToRefresh: () => {
			return new Promise((resolve) => {
				setTimeout(() => {
					eventHandler.update();
					dispatch(updateBranchPeriodInfo(false));
					resolve();
				}, 700);
			});
		}
	};

	const render = () => {
		const getTitle = () => {
			const periodTypeName = (mode == "daily") ? "일간" : (mode == "weekly") ? "주간" : (mode == "monthly") ? "월간" : "";
			return `전 지점 ${periodTypeName} 매출`;
		};
		const isChart = (mode != "daily");
		return (
			<PullToRefresh
				onRefresh={eventHandler.pullToRefresh}
				resistance={2}
				pullingContent={<></>}
				refreshingContent={<PullToRefreshing />}
			>
				<MainLayout
					withHeader={true}
					headerProps={{
						withBackButton : true,
						centerTitle : getTitle()
					}}
					backgroundColor="white"
					withBottomTab={false}
				>
					<SummaryInfo
						mode={mode}
						date={searchDate}
						data={data}
						isChart={isChart}
						isLoading={isLoading}
						isError={isError}
						onChange={eventHandler.changeDate}
						onRefresh={eventHandler.update}
					/>
					<BranchDetailList mode={mode} />
				</MainLayout>
			</PullToRefresh>
		);
	};
	return render();
};

export default BranchDetail;